// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AlertController from "./alert_controller";
application.register("alert", AlertController);

import CalendarController from "./calendar_controller";
application.register("calendar", CalendarController);

import GenerationSelectController from "./generation_select_controller";
application.register("generation-select", GenerationSelectController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import UserFormController from "./user_form_controller";
application.register("user-form", UserFormController);
